import {
  faArrowLeftLong,
  faClock,
  faCoins,
  faFileContract,
  faLink,
  faPersonChalkboard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADEMICYEARID,
  ACADIMAC,
  ADDLESSON,
  baseURL,
  EDITEXAM,
  EDITLESSON,
  UPDATEEXAM,
  UPDATELESSON,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function UpdateTest() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const [Academacs, setAcademacs] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [data, setData] = useState({
    academicYear: "",
    chapter: "",
    examName: "",
    time: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }

  //1/ جلب بيانات الشهر للتعديل
  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${EDITEXAM}/${id}/`)
        .then((res) => {
          setData({
            academicYear: res.data.data.academic_year_id || "",
            chapter: res.data.data.chapter_id || "",
            examName: res.data.data.name || "",
            time: res.data.data.time || "",
          });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الشهر");
        });
    }
  }, [id, axiosPrivate]);

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const response = await axiosPrivate.put(`${baseURL}/${UPDATEEXAM}/`, {
        ...data,
        save,
        id,
      });

      toast.success("تم الحفظ بنجاح");

      setData({
        academicYear: "",
        chapter: "",
        examName: "",
        time: "",
      });

      if (nav) {
        Navigate("/DashboardLayout/tests/create-test");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);

      if (error.response && error.response.status === 400) {
        toast.error("لم يتم الحفظ، قد تكون البيانات مكررة أو غير صحيحة");
      } else {
        toast.error("حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً");
      }
    } finally {
      setLoding(false);
    }
  }

  useEffect(() => {
    async function featchmonth() {
      const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);

      setAcademacs(res.data.data);
    }

    featchmonth();
  }, [axiosPrivate]);

  useEffect(() => {
    async function featchmonth() {
      if (data.academicYear) {
        const res = await axiosPrivate.get(
          `${baseURL}/${ACADEMICYEARID}/${data.academicYear}`
        );
        setSelectData(res.data.data);
      }
    }
    featchmonth();
  }, [data.academicYear, axiosPrivate]);

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/tests/create-test"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold">تعديل الاختبار</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="mb-5" controlId="city">
              <Form.Label> المرحلة الدراسيه</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicYear"
                value={data.academicYear}
                onChange={handleChange}
              >
                <option value="">----</option>
                {Academacs.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-5" controlId="city">
              <Form.Label> الشهر الدراسي:</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="chapter"
                value={data.chapter}
                onChange={handleChange}
              >
                <option value="">----</option>
                {selectData.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="examName"
                value={data.examName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon
                  className="iconeForm"
                  icon={faPersonChalkboard}
                />
                <span className="textinpout">اسم الاختبار</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="time"
                value={data.time}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faClock} />
                <span className="textinpout">وقت الاختبار:</span>
              </Form.Label>
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                إضافة
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
